
riot.tag2('delivery-list-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">{parent.opts.title || \'Справочник доставок\'}</div>\n    </yield>\n    <yield to="body">\n      <catalog object="Delivery" cols="{parent.cols}" reload="true" handlers="{parent.handlers}" dblclick="{parent.opts.submit.bind(this)}">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="name">{row.name}</datatable-cell>\n          <datatable-cell name="code">{handlers.types[row.code].name}</datatable-cell>\n          <datatable-cell name="period">{row.period != 0 ? row.period + ⁗ дн.⁗ : ⁗⁗}</datatable-cell>\n          <datatable-cell name="price"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {parseInt(row.price).toFixed(2)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n          <datatable-cell name="note">{row.note}</datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('remove');
self.collection = 'Delivery';
self.handlers = {};

self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'code', value: 'Тип' }, { name: 'period', value: 'Период' }, { name: 'price', value: 'Цена' }, { name: 'note', value: 'Примечание' }];

self.on('mount', function () {
    API.request({
        object: 'DeliveryType',
        method: 'Fetch',
        success: function success(response) {
            self.handlers.types = {};
            response.items.forEach(function (item) {
                self.handlers.types[item.id] = {
                    code: item.code,
                    name: item.name
                };
            });
        },
        error: function error(response) {
            self.handlers.types = {};
        },
        complete: function complete() {
            self.update();
        }
    });
});
});


// WEBPACK FOOTER //
// ./pages/delivery/delivery-list-modal.tag